"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCssVariableFromElement = exports.getCssVariable = exports.getAwardColor = exports.changedKeys = void 0;
const changedKeys = (o1 = {}, o2 = {}) => {
    const keys = _.union(_.keys(o1), _.keys(o2));
    return _.filter(keys, (key) => o1[key] !== o2[key]);
};
exports.changedKeys = changedKeys;
const getAwardColor = (award) => {
    const category = award.obtainedAt ? award.category : 'default';
    switch (category) {
        case 'bonus-assignments':
            return 'blue';
        case 'blood-donation':
            return 'red';
        case 'endurance':
            return 'orange';
        case 'shares':
            return 'pink';
        default:
            return 'default';
    }
};
exports.getAwardColor = getAwardColor;
const getCssVariable = (variable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
};
exports.getCssVariable = getCssVariable;
const getCssVariableFromElement = (element, variable) => {
    return getComputedStyle(element).getPropertyValue(variable);
};
exports.getCssVariableFromElement = getCssVariableFromElement;
